import { render, staticRenderFns } from "./XCheckbox.vue?vue&type=template&id=c02276a8&scoped=true"
import script from "./XCheckbox.vue?vue&type=script&lang=js"
export * from "./XCheckbox.vue?vue&type=script&lang=js"
import style0 from "./XCheckbox.vue?vue&type=style&index=0&id=c02276a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c02276a8",
  null
  
)

export default component.exports